import React, { useState, useRef, useEffect } from 'react';
import { Form, Button, Card, Alert, Container, Modal } from "react-bootstrap";
import { useAuth } from '../../contexts/AuthContext';
import { firestore } from '../../firebase';
//import firebase from "firebase/app";

export default function Profile() {
    const currentPasswordRef = useRef();
    const newPasswordRef = useRef();
    const newPasswordConfirmRef = useRef();
    const { currentUser, /*updatePassword*/ } = useAuth();
    const [check, setCheck] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [changeCounter, setChangeCounter] = useState(0);

    function handleSubmit(e) {
        e.preventDefault();

        setLoading(true);
        setError("No tiene permiso para realizar esta acción");
        setLoading(false);
        return;

        /*if (newPasswordRef.current.value.length < 6) {
            setLoading(false);
            return setError('La contraseña debe contener al menos 6 caracteres');
        }

        if (newPasswordRef.current.value !==
            newPasswordConfirmRef.current.value) {
                setLoading(false);
                return setError('Las contraseñas no coinciden');
            }

        const credential = firebase.auth.EmailAuthProvider.credential(
            currentUser.email,
            currentPasswordRef.current.value
        );

        currentUser.reauthenticateWithCredential(credential)
        .then(() => {
            updatePassword(newPasswordRef.current.value)
            .then(() => {
                currentPasswordRef.current.value = '';
                newPasswordRef.current.value = '';
                newPasswordConfirmRef.current.value = '';
                setShowAlert(true);
                setLoading(false);
            })
            .catch(() => {
                setError('Error inesperado al cambiar contraseña')
                setLoading(false);
            })
        })
        .catch(() => {
            setError('Contraseña actual incorrecta')
            setLoading(false);
        })*/
    }

    function handleCheckChange(e) {
        e.preventDefault();
        setLoading(true);

        const uid = currentUser.uid;
        firestore.collection('usuarios').doc(uid).update({recibirCorreos: !check})
        .then(() => {
            setChangeCounter(changeCounter+1);
            setCheck(!check);
        })
        .finally(() => {
            setLoading(false);
        })
    }

    useEffect(() => {
        setError('');
        setLoading(true);
        const uid = currentUser.uid;
        firestore.collection('usuarios').doc(uid).get()
        .then((userDoc) => {
            setCheck(userDoc.data().recibirCorreos);
        })
        .finally(() => {
            setLoading(false);
        })
    }, [changeCounter, currentUser.uid])

    return (
        <Container 
        className="d-flex align-items-center justify-content-center"
        style = {{ minHeight: "90vh" }}
        >
            <div className="w-100" style = {{ maxWidth: "600px"}}>
                <Modal show={showAlert} onHide={() => setShowAlert(false)} animation={false}>
                    <Modal.Header>
                        <Modal.Title>Éxito</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Su contraseña se ha cambiado exitosamente
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => setShowAlert(false)}>
                            Aceptar
                        </Button>
                    </Modal.Footer>
                </Modal>
                <h2 className="text-center mb-4">Configuración del Perfil</h2>
                <strong className="text-center mb-3">Email: </strong> {currentUser.email}
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Check 
                        type="checkbox"
                        disabled={loading}
                        checked={check}
                        onChange={handleCheckChange}
                        label="Deseo recibir un correo cuando queden pocas existencias de un producto" 
                        />
                    </Form.Group>
                </Form>
                <Card>
                    <Card.Body>
                        <h4 className="text-left mb-3">Cambiar contraseña</h4>
                        {error && <Alert variant="danger">{error}</Alert>}
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3" id="current-password">
                                <Form.Label>Contraseña actual</Form.Label>
                                <Form.Control type="password" ref={currentPasswordRef}/>
                            </Form.Group>
                            <Form.Group className="mb-3" id="new-password">
                                <Form.Label>Nueva contraseña</Form.Label>
                                <Form.Control type="password" ref={newPasswordRef}/>
                            </Form.Group>
                            <Form.Group className="mb-3" id="new-password-confirm">
                                <Form.Label>Confirmar nueva contraseña</Form.Label>
                                <Form.Control type="password" ref={newPasswordConfirmRef}/>
                            </Form.Group>
                            <Button disabled={loading} type="submit">Guardar</Button>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </Container>
    )
}